/* header-drawer.js
   Loaded with `defer` from snippets/header-drawer.liquid.

   Replaces:
   - The inline onclick="window.location.href='...'" on the AI Skin Test button
   - The inline onclick="window.gtag(...)" on every nav link
   - The two inline <script> blocks that used to sit at the bottom of
     header-drawer.liquid (.parent-link handler — dead code, no element
     in the live markup used that class — and the .nav-link__multi__container__title
     custom toggle + gtag tracking, which IS live and is reproduced below)
*/
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  onReady(function () {
    // --------------------------------------------------------------
    // Single delegated click listener for the whole drawer:
    // - AI Skin Test redirect
    // - gtag click tracking on every nav link (data-track-click)
    // --------------------------------------------------------------
    document.addEventListener('click', function (e) {
      var skinBtn = e.target.closest('[data-skin-analyzer]');
      if (skinBtn) {
        window.location.href = skinBtn.getAttribute('data-skin-analyzer');
        return;
      }

      var trackEl = e.target.closest('[data-track-click]');
      if (trackEl && window.gtag) {
        var eventName = trackEl.getAttribute('data-track-click');
        window.gtag('event', eventName, {
          event_category: eventName,
          event_label: eventName,
          option_clicked: trackEl.getAttribute('data-track-option') || '',
          parent_category: trackEl.getAttribute('data-track-parent') || ''
        });
      }
    });

    // --------------------------------------------------------------
    // Multi-level dropdown (.nav-link__multi__container, a <details>):
    // clicking the title toggles it open/closed (closing any sibling
    // dropdown first), and fires a gtag event the first time it opens.
    // --------------------------------------------------------------
    document.querySelectorAll('.nav-link__multi__container__title').forEach(function (title) {
      var details = title.closest('details');
      if (!details) return;

      title.addEventListener('click', function (e) {
        e.preventDefault();

        var isOpening = !details.hasAttribute('open');

        document.querySelectorAll('details[open]').forEach(function (openDetails) {
          if (openDetails !== details) openDetails.removeAttribute('open');
        });

        details.toggleAttribute('open');

        if (isOpening && window.gtag) {
          window.gtag('event', 'hamburger_category_open', {
            event_category: 'hamburger_category_open',
            event_label: 'hamburger_category_open',
            title: details.getAttribute('data-category-title') || '',
            dropdown: details.getAttribute('data-dropdown-items') || ''
          });
        }
      });
    });
  });
})();